export const supportFormSection = {
  eyebrow: 'GET IN TOUCH',
  title: 'How can we help?',
  body: 'We typically reply within two business days. For urgent matters, mention it in your message.',
} as const;

export const supportFindUs = {
  eyebrow: 'FIND US',
  title: 'Barcelona',
  company: 'MedBioInformatics Solutions S.L.',
  lines: ['Rambla de Catalunya, 14, 7º, 1ª', '08007 Barcelona, Spain'],
  mapEmbedSrc:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2993.3454629823714!2d2.162852784754208!3d41.38830339729827!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a4a2f2528cd1a7%3A0xcab870e40ece5da8!2sRambla%20de%20Catalunya%2C%2014%2C%2008007%20Barcelona!5e0!3m2!1ses-419!2ses!4v1699352156342!5m2!1ses-419!2ses',
} as const;

export const supportHelpCenter = {
  body: 'You can also find answers to common questions in our Help Center.',
  buttonLabel: 'Visit Help Center',
  url: 'https://disgenet.freshdesk.com/support/home',
} as const;
